import useLogoUrlReplacement from 'components/Dashboard/UserContent/ui/useLogoUrlReplacement';

interface UploadHubLandingPreviewProps {
  organisationLogo: string | null;
  backgroundColour: string;
  barBackgroundColour: string;
}

const UploadHubLandingPreview = (props: UploadHubLandingPreviewProps) => {
  const { organisationLogo, backgroundColour, barBackgroundColour } = props ?? {};
  const { clientLogoReplacement } = useLogoUrlReplacement();
  const logoUrl = organisationLogo?.startsWith('data:')
    ? organisationLogo
    : clientLogoReplacement({ organisationLogo });

  return (
    <div className='rounded border overflow-hidden' style={{ backgroundColor: backgroundColour }}>
      <div
        className='flex-centered specific-x-padding-14 specific-y-padding-4 justify-content-between border-bottom'
        style={{ backgroundColor: barBackgroundColour }}
      >
        {organisationLogo && (
          <img
            src={logoUrl}
            alt='Organisation logo'
            style={{ borderRadius: '2px', height: '11px', objectFit: 'cover' }}
          />
        )}
      </div>
      <div className='py-3 px-5'>
        <div className='rounded overflow-hidden'>
          <div
            className='bg-white border flex-centered justify-content-center mx-auto'
            style={{ height: '142px', maxWidth: '120px' }}
          >
            <p className='mb-0 main-light-text'>Your file</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadHubLandingPreview;
